// import logo from"../../../../public/projects/ekta-world/"
import Eden62 from "../../../../public/projects/ekta-world/projects/Eden62.jpg";
import Parksville from "../../../../public/projects/ekta-world/projects/Parksville.jpg";
import logo from "../../../../public/projects/ekta-world/logo/logo.png";

//ektaeden62
import overviewImage_eden62 from "../../../../public/projects/ekta-world/images/eden62/Overview/1.webp";
import bannerDesktopImage_eden62 from "../../../../public/projects/ekta-world/images/eden62/Banner/1.webp";
import bannerMobileImage_eden62 from "../../../../public/projects/ekta-world/images/eden62/Banner/2.webp";
import siteVisitBannerImage_eden62 from "../../../../public/projects/ekta-world/images/eden62/SiteVisitBanner/1.webp";
import Location_eden62 from "../../../../public/projects/ekta-world/images/eden62/Location/L1.webp";
import Hightlights_eden62 from "../../../../public/projects/ekta-world/images/eden62/Highlights/1.webp";
import image1BHK_eden62 from "../../../../public/projects/ekta-world/images/eden62/floorplan/1.webp";
import location_eden62 from "../../../../public/projects/ekta-world/images/eden62/Overview/l.png";
import cal_eden62 from "../../../../public/projects/ekta-world/images/eden62/Overview/c.png";
import newlaunch_eden62 from "../../../../public/projects/ekta-world/images/eden62/Overview/n.png";
import g1_eden62 from "../../../../public/projects/ekta-world/images/eden62/Gallery/1.webp";
import g2_eden62 from "../../../../public/projects/ekta-world/images/eden62/Gallery/2.webp";
import g3_eden62 from "../../../../public/projects/ekta-world/images/eden62/Gallery/3.webp";
import g4_eden62 from "../../../../public/projects/ekta-world/images/eden62/Gallery/4.webp";
import g5_eden62 from "../../../../public/projects/ekta-world/images/eden62/Gallery/5.webp";

// parksvillephase4
import overviewImage_parksvillerphase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Overview/1.webp";
import bannerDesktopImage_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Banner/1.webp";
import bannerMobileImage_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Banner/2.webp";
import siteVisitBannerImage_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/SiteVisitBanner/1.webp";
import Location_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Location/L1.webp";
import Hightlights_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Highlights/1.webp";
import image1BHK_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/floorplan/1.webp";
import image2BHK_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/floorplan/2.webp";
import image3BHK_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/floorplan/3.webp";
import location_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Overview/l.png";
import cal_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Overview/c.png";
import newlaunch_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Overview/n.png";
import g1_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Gallery/1.webp";
import g2_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Gallery/2.webp";
import g3_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Gallery/3.webp";
import g4_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Gallery/4.webp";
import g5_parksvillephase4 from "../../../../public/projects/ekta-world/images/parksvillephase4/Gallery/5.webp";

export const developersEktaworld = {
  name: `Ekta World - Properties in Mumbai`,
  properties: [
    {
      name: "Ekta World - Eden 62",
      image: Eden62,
      price: "On Request",
      location: "Juhu",
      projectlocation:"East Mumbai",
      bed: "4 BHK",
      state: "Mumbai",
      developer: "Ekta World",
      size: "2749.18 sq.ft.",
      url: `/ekta-eden-62-juhu-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Ekta World - Parksville Phase 4",
      image: Parksville,
      price: "On Request",
      location: "Mira Road",
      projectlocation: "East Mumbai",
      state: "Mumbai",
      developer: "Ekta World",
      bed: "1 -2 -3 BR Apartments",
      size: "On Request",
      url: `/ekta-parksville-phase-4-virar-west-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    // {
    //   name: "Ekta World - Tripolis Phase 2",
    //   image: Tripolis,
    //   price: "On Request",
    //   location: "Mumbai",
    //   projectlocation: "Borivali,Mumbai",
    //   state: "Mumbai",
    //   developer: "Ekta World",
    //   bed: "2 - 3 BR Apartments",
    //   size: "On Request",
    //   url: `/developers/birla/birla-estate`,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   },
    // },
    // {
    //   name: "Ekta World - Lake Riviera Wing C",
    //   image: Lake,
    //   price: "On Request",
    //   location: "Powai, Mumbai",
    //   projectlocation: "East Mumbai",
    //   state: "Mumbai",
    //   developer: "Ekta World",
    //   bed: "2, 3 BHK Apartments",
    //   size: "631 - 995 sq.ft.",
    //   url: `/developers/birla/birla-estate`,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   },
    // },
    // {
    //   name: "Ekta World - Eros",
    //   image: Eros,
    //   price: "On Request",
    //   location: "Mumbai",
    //   projectlocation: "East, Mumbai",
    //   state: "Mumbai",
    //   developer: "Ekta World",
    //   bed: "3 BHK Apartments",
    //   size: "796 - 1212 sq.ft.",
    //   url: `/developers/birla/birla-estate`,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   },
    // },
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1987",
  },
  about: `EKTA World was founded in 1987. Since then, the business has expanded steadily. The group has constructed the most upscale residential complexes in Mumbai's western suburbs between Bandra and Dahisar, the upscale NIBM road in Pune, and a worldwide residential community close to Pandav Leni's heritage site in Nashik. Along with creating landmark buildings, the group has also taken care of the comfort and wants of its citizens, giving the city's skyline a dash of glitz and elegance. `,
};

export const projectsektaworld = {
  ektaeden62: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_eden62,
      bannerMobileImage: bannerMobileImage_eden62,
      textOverlay: "",
      data: {
        title: "Ekta Eden 62",
        subtitle: "Juhu, Mumbai",
        starting_price: "On Request",
        rerano:"P51800076914",
        payment_plan: "CLP",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Ekta Eden 62 – Luxury Living in Juhu, Mumbai by Ekta World",
      description: [
        `Ekta Eden 62 by Ekta World is a premium residential project in the heart of Juhu, Mumbai, offering an exclusive lifestyle with world-class amenities. Designed for luxury and comfort, this elegant development provides spacious homes with modern architecture, high-end interiors, and breathtaking city views.

Strategically located in Juhu, one of Mumbai’s most prestigious neighborhoods, Ekta Eden 62 ensures seamless connectivity to key areas, including top schools, entertainment hubs, shopping centers, and fine-dining restaurants. The project offers well-planned residences with state-of-the-art features, promising a perfect blend of style and functionality.`,
      ],
      image: overviewImage_eden62,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_eden62,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_eden62,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_eden62,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_eden62,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "On Request",
        price: "On Request",
        image: image1BHK_eden62,
      },
      {
        type: "5 BHK",
        area: "On Request",
        price: "On Request",
        image: image1BHK_eden62,
      },
      //
    ],

    highlights: {
      images: Hightlights_eden62,
      tagline: "Highlights",
      features: [
        "Located in Juhu, with easy access to Swami Vivekanand Road",
        "Minutes from Western Express Highway, perfect connectivity",
        "Relish luxurious lifestyle with ample amenities",
        "Luxurious 1/2/3 BHK apartments with quality specifications",
        "24x7 power backup and robust security assured",
      ],
    },

    location: {
      image: Location_eden62,
      data:[
        {
          airport:{
            distance_time:"1.2 Km",
            name:"Juhu Airport"
          },
          school:{
            distance_time:"500 m",
            name:"JNI School"
          },
          railwayormetro:{
            distance_time:"1.44 Km",
            name:"Andheri West"
          },
          hospital:{
            distance_time:"400 m",
            name:"Copper Hospital"
          },
          mall:{
            distance_time:"4.6 Km",
            name:"Infinity Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_eden62 },
        { image: g2_eden62 },
        { image: g3_eden62 },
        { image: g4_eden62 },
        { image: g5_eden62 },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Ekta Eden 62, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The project is called Ekta Eden 62.`  },
      {
        question: "Who is the developer of Ekta Eden 62?",
        answer: `The project is developed by Ekta World.` },
      {
        question: "Where is Ekta Eden 62 located?",
        answer: `It is located in Juhu, Mumbai.`  },
      {
        question: "What types of apartments are available in Ekta Eden 62?",
        answer: `The project offers 4 BHK and 5 BHK apartments.`  },
      {
        question: "What is the area of the 4 BHK apartments in Ekta Eden 62?",
        answer: `The area of the 4 BHK apartments is on request.`  },
      {
        question: "What is the area of the 5 BHK apartments in Ekta Eden 62?",
        answer: `The area of the 5 BHK apartments is on request.`   },
      {
        question: "What is the starting price of apartments in Ekta Eden 62?",
        answer: `The starting price is on request.`  },
      {
        question: "What is the current status of Ekta Eden 62?",
        answer: `It is a New Launch project.`    },
      {
        question: "Which city is Ekta Eden 62 located in?",
        answer: `It is in Mumbai.
`  },
      {
        question: "What is the configuration of the largest apartment in Ekta Eden 62?",
        answer: `The largest apartment configuration is 5 BHK.` },
    ],
    similar: {
      properties: [
      
        {
          name: "Ekta World - Parksville Phase 4",
          image: Parksville,
          price: "On Request",
          location: "Mumbai East",
          projectlocation: "Mira Road",
          state: "Mumbai",
          developer: "Ekta World",
          bed: "1 -2 -3 BR Apartments",
          size: "On Request",
          url: `/ekta-parksville-phase-4-virar-west-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        // {
        //   name: "Ekta World - Tripolis Phase 2",
        //   image: Tripolis,
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Borivali,Mumbai",
        //   state: "Mumbai",
        //   developer: "Ekta World",
        //   bed: "2 - 3 BR Apartments",
        //   size: "On Request",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
        // {
        //   name: "Ekta World - Lake Riviera Wing C",
        //   image: Lake,
        //   price: "On Request",
        //   location: "Powai, Mumbai",
        //   projectlocation: "West Mumbai",
        //   state: "Mumbai",
        //   developer: "Ekta World",
        //   bed: "2, 3 BHK Apartments",
        //   size: "631 - 995 sq.ft.",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
        // {
        //   name: "Ekta World - Eros",
        //   image: Eros,
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "West, Mumbai",
        //   state: "Mumbai",
        //   developer: "Ekta World",
        //   bed: "3 BHK Apartments",
        //   size: "796 - 1212 sq.ft.",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },

  parksvillephase4: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_parksvillephase4,
      bannerMobileImage: bannerMobileImage_parksvillephase4,
      textOverlay: "",
      data: {
        title: "Parksville Phase 4",
        subtitle: "Virar West, Palghar",
        starting_price: "28 L",
        rerano:"P99000015239",
        payment_plan: "CLP",
        status: "Ready To Move",
      },
    },
    overview: {
      heading: "Ekta Parksville Phase 4 – Premium Homes in Virar West, Palghar",
      description: [
        `Ekta Parksville Phase 4 by Ekta World is a premium residential project in Virar West, Palghar, offering well-designed homes with modern amenities. Strategically located, it provides excellent connectivity to Mumbai while ensuring a peaceful lifestyle in a rapidly developing neighborhood. The project features spacious apartments with contemporary interiors, ample natural light, and high-quality finishes. 

Residents can enjoy world-class amenities, including a swimming pool, clubhouse, gymnasium, landscaped gardens, children’s play area, and 24/7 security. With growing infrastructure and affordability, Ekta Parksville Phase 4 is an ideal choice for homebuyers and investors looking for a blend of comfort, convenience, and long-term value.`,
      ],
      image: overviewImage_parksvillerphase4,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_parksvillephase4,
          title: "28 L ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_parksvillephase4,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_parksvillephase4,
          title: "Ready To Move",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_parksvillephase4,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK",
          area: "337 - 363 sq. ft.",
          price: "28 L",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK",
          area: "449 - 521 sq. ft.",
          price: "42 - 59.91 L",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "1 BHK",
          area: "337 - 363 sq. ft.",
          price: "28 L",
        image: image1BHK_parksvillephase4,
      },
      {
        type: "2 BHK",
          area: "449 - 521 sq. ft.",
          price: "42 - 59.91 L",
        image: image2BHK_parksvillephase4,
      },
      {
        type: "3 BHK",
          area: "On Request",
          price: "On Request",
        image: image3BHK_parksvillephase4,
      },
      //
    ],

    highlights: {
      images: Hightlights_parksvillephase4,
      tagline: "Highlights",
      features: [
        "Elevate your lifestyle in Virar West priciest residential destination.",
        "Enjoy strategic proximity to Veer Savarkar Road and Mumbai-Delhi Highway.",
        "Nest among lush green environments with a tranquil ambiance.",
        "Experience world-class amenities like gyms and power backup.",
        "Indulge in stylish living with oil-bound distemper walls and vitrified tiles flooring.",
      ],
    },

    location: {
      image: Location_parksvillephase4,
      data:[
        {
          airport:{
            distance_time:"57.5 Km",
            name:"CSMI Airport"
          },
          school:{
            distance_time:"600 m",
            name:"Samarth School"
          },
          railwayormetro:{
            distance_time:"2.5 Km",
            name:"Virar Railway Station"
          },
          hospital:{
            distance_time:"5.1 Km",
            name:"Riddhi Vinayak "
          },
          mall:{
            distance_time:"2 Km",
            name:"Magnet Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_parksvillephase4 },
        { image: g2_parksvillephase4 },
        { image: g3_parksvillephase4 },
        { image: g4_parksvillephase4 },
        { image: g5_parksvillephase4 },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Parksville Phase 4, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The project is called Parksville Phase 4.`   },
      {
        question: "Who is the developer of Parksville Phase 4?",
        answer: `The developer is Ekta World.`  },
      {
        question: "Where is Parksville Phase 4 located?",
        answer: `It is located in Virar West, Palghar.`  },
      {
        question: "What types of apartments are available in the project?",
        answer: `The project offers 1 BHK, 2 BHK, and 3 BHK apartments.`   },
      {
        question: "What is the area range for 1 BHK apartments?",
        answer: `The area for 1 BHK apartments ranges from 337 - 363 sq. ft.
`  },
      {
        question: "What is the price of a 1 BHK apartment?",
        answer: `The price for a 1 BHK apartment starts at ₹28 Lakh.` },
      {
        question: "What is the area range for 2 BHK apartments?",
        answer: `The area for 2 BHK apartments ranges from 449 - 521 sq. ft.`  },
      {
        question: "What is the price range for 2 BHK apartments?",
        answer: `The price for 2 BHK apartments ranges from ₹42 Lakh to ₹59.91 Lakh.`   },
      {
        question: "What is the area of 3 BHK apartments?",
        answer: `The area for 3 BHK apartments is available on request.`    },
      {
        question: "What is the starting price of apartments in Parksville Phase 4?",
        answer: `The starting price is ₹28 Lakh.`  },
    ],
    similar: {
      properties: [
        {
          name: "Ekta World - Eden 62",
          image: Eden62,
          price: "On Request",
          location: "Mumbai East",
          bed: "4 BHK",
          state: "Mumbai",
          developer: "Ekta World",
          size: "2749.18 sq.ft.",
          url: `/ekta-eden-62-juhu-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
